import React from 'react';
import {useIsMaxSm} from 'features/auth/ui/AuthorizationSteps/useIsMaxSm';
import {Drawer} from 'shared/ui/Drawer';
import {ProfileDocumentIconView} from '../ProfileDocumentsList/ProfileDocumentIcons';
import styles from './TaxIdentifierDrawer.module.css';

export type TaxIdentifierDrawerProps = {
	open: boolean;
	value: string;
	onClose: () => void;
};

export function TaxIdentifierDrawer({open, value, onClose}: TaxIdentifierDrawerProps): React.ReactElement {
	const isMaxSm = useIsMaxSm();

	return (
		<Drawer
			open={open}
			onClose={onClose}
			showCloseButton
			variant={isMaxSm ? 'fullscreen' : 'side'}
			bodyClassName={styles.drawerBody}
		>
			<div className={styles.hero}>
				<h2 className={styles.title}>Налоговый идентификатор</h2>
				<span className={styles.heroIcon} aria-hidden>
					<ProfileDocumentIconView name="inn" className={styles.icon} />
				</span>
			</div>

			<div className={styles.infoBlock}>
				<p className={styles.label}>Налоговый идентификатор</p>
				<p className={styles.value}>{value}</p>
			</div>
		</Drawer>
	);
}
